// TODO SYN-5643: Delete this entire file once the admin menu page is set up
// This context was created as a temporary workaround to open the admin nav drawer from the Menu page
import { createContext, ReactNode, useCallback, useContext, useState } from 'react'

type NavDrawerContextType = {
  openDrawer: () => void
  openDrawerInAdminMode: () => void
  registerOpenDrawer: (openDrawer: () => void) => void
  registerSetMode: (setMode: (mode: 'default' | 'admin') => void) => void
  shouldOpenDrawerOnAdminMode: boolean
  setShouldOpenDrawerOnAdminMode: (should: boolean) => void
}

const NavDrawerContext = createContext<NavDrawerContextType | undefined>(undefined)

export const NavDrawerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openDrawerFn, setOpenDrawerFn] = useState<(() => void) | null>(null)
  const [setModeFn, setSetModeFn] = useState<((mode: 'default' | 'admin') => void) | null>(null)
  const [shouldOpenDrawerOnAdminMode, setShouldOpenDrawerOnAdminMode] = useState(false)

  const registerOpenDrawer = useCallback((openDrawer: () => void) => {
    setOpenDrawerFn(() => openDrawer)
  }, [])

  const registerSetMode = useCallback((setMode: (mode: 'default' | 'admin') => void) => {
    setSetModeFn(() => setMode)
  }, [])

  const openDrawer = useCallback(() => {
    if (openDrawerFn) {
      openDrawerFn()
    }
  }, [openDrawerFn])

  const openDrawerInAdminMode = useCallback(() => {
    if (setModeFn) {
      setShouldOpenDrawerOnAdminMode(true)
      setModeFn('admin')
    }
  }, [setModeFn])

  return (
    <NavDrawerContext.Provider
      value={{
        openDrawer,
        openDrawerInAdminMode,
        registerOpenDrawer,
        registerSetMode,
        shouldOpenDrawerOnAdminMode,
        setShouldOpenDrawerOnAdminMode,
      }}>
      {children}
    </NavDrawerContext.Provider>
  )
}

export const useNavDrawer = () => {
  const context = useContext(NavDrawerContext)
  if (context === undefined) {
    throw new Error('useNavDrawer must be used within a NavDrawerProvider')
  }
  return context
}
